<template>
<div class="chapter">
<div class="inner_page">
<div class="calibre1">
<p class="calibre32"> <span class="calibre5">Present Day</span><span class="calibre33"></span> </p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// part0004_split_000.vue?136e3968